import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { OmniGeralRestService } from './../../omni-rest/omni-geral/omni-geral-rest.service';

@Injectable()
export class AtributoTemporalService {
  constructor(private _restService: OmniGeralRestService) {}

  public listar(atributo?: any) {
    return this._restService
      .get('atributo-temporal', { params: { atributo } })
      .pipe(timeout(20000))
      .toPromise();
  }
}
